/* Add new content for a category by adding a new prop to the map
*  Do this via supportContent.new_prop_name
*/
import InfoIcon from "@mui/icons-material/Info";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditIcon from "@mui/icons-material/ModeEdit";

const supportContent: any = {}

supportContent.IntervalSet = "Intervals can be organized into INTERVAL SETS. An INTERVAL SET is primarily a logical way to group intervals. This helps to organize intervals logically and also allows common interval sets to be shared between pathways without having to duplicate the effort of recreating a shared set of intervals for every pathway."
supportContent.SendOnceDuringInterval = "Only one such message of this priority will be sent for during this interval, even if from multiple sources. This is to avoid spamming the recipient in cases where they have a lot of communications. Lower priority messages will send out after higher priority messages."
supportContent.SendMultipleTimesPerInterval = "Send a limited number of times. Frequency will determine how often to send the messages and how long to wait if we’ve already sent a message of the same or high priority to avoid spamming the recipient."
supportContent.SendOnARegularSchedule = "Send until the interval ends or the recipient completes the required interactions. Frequency will determine how often to send the messages and how long to wait if we’ve already sent a message of the same or high priority to avoid spamming the recipient."

supportContent.CommSetInstructions = (
  <div style = {{wordWrap: "break-word"}}>
    <p style={{ fontSize: "8pt",  }}>
      <InfoIcon sx={{ fontSize: "12pt", color: "rgb(17, 80, 142)" }} />
      &nbsp; Click   <span style={{ fontWeight: "bolder", color: "rgb(17, 80, 142)" }}>
        <SaveIcon sx={{ fontSize: "10pt", color: "rgb(17, 80, 142)" }} />
        SAVE
      </span> &nbsp;to add communications set to this interval
    </p>
    <p style={{ fontSize: "8pt" }}>

      <InfoIcon sx={{ fontSize: "12pt", color: "rgb(17, 80, 142)" }} />
      &nbsp; Click
      <DeleteIcon
        sx={{ fontSize: "10pt", color: "rgb(17, 80, 142)" }}
      />{" "}
      <span style={{ fontWeight: "bolder", color: "rgb(17, 80, 142)" }}>
        DELETE
      </span>{" "}
      to remove all communication sets from interval
    </p>

    <p style={{ fontSize: "8pt", marginTop: "-20px" }}>

      <InfoIcon
        sx={{
          fontSize: "12pt",
          color: "rgb(17, 80, 142)",
          marginTop: "20px",
        }}
      />
      &nbsp; Shared Communications are locked for editing. Click{" "}
      <ModeEditIcon
        sx={{ fontSize: "10pt", color: "rgb(17, 80, 142)" }}
      />{" "}
      to edit.
    </p>
    <p style={{ fontSize: "8pt" }}>
      <InfoIcon
        sx={{ fontSize: "12pt", color: "rgb(17, 80, 142)" }}
      />
      &nbsp; To attach a different commset, select
      from dropdown and &nbsp; 
      <SaveIcon
        sx={{ fontSize: "10pt", color: "rgb(17, 80, 142)" }}
      />{" "}
      <span
        style={{
          fontWeight: "bolder",
          color: "rgb(17, 80, 142)",
        }}
      >
        SAVE
      </span>
    </p>
  </div>
)




export default supportContent;

//                          <SearchIcon />
//                           <FileCopyOutlinedIcon />
//                         <DeleteIcon />

